import { useMemo } from 'react';
import { useGetPresentacionQuery } from '../../../../services/presentacionesApi';
import { useGetRecomendacionesVerosimilitudQuery } from '../../../../services/visitasApi';
import { useAppDispatch } from '../../../../hooks/reduxHooks';

const useRGRLVerosimilitud = (idPresentacion: number | undefined) => {
    const dispatch = useAppDispatch();
    const {
        data: responsePresentacion,
        error,
        isLoading
    } = useGetPresentacionQuery(idPresentacion);

    const { data: recomendacionesData } = useGetRecomendacionesVerosimilitudQuery();

    const responsePresentacionConRecomendaciones = useMemo(() => {
        if (!responsePresentacion) return responsePresentacion;

        const recomendacionesPorPregunta = new Map(
            (recomendacionesData?.data ?? []).map((pregunta) => [
                pregunta.id,
                pregunta.recomendaciones
            ])
        );

        return {
            ...responsePresentacion,
            solapas: (responsePresentacion as any).solapas?.map((solapa: any) => ({
                ...solapa,
                secciones: solapa.secciones?.map((seccion: any) => ({
                    ...seccion,
                    preguntas: seccion.preguntas?.map((pregunta: any) => ({
                        ...pregunta,
                        recomendaciones: recomendacionesPorPregunta.get(pregunta.id) ?? []
                    }))
                }))
            }))
        };
    }, [responsePresentacion, recomendacionesData]);

    return {
        responsePresentacion: responsePresentacionConRecomendaciones,
        error,
        isLoading
    };
};

export default useRGRLVerosimilitud;
